import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { DamzContext } from '@wix/da-react-context/pkg/DamzContext';
import React, { useContext } from 'react';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';

export interface Props {}

const DamzInit: React.FC<Props> = () => {
  const { GlobalComponent } = useContext(DamzContext);
  const isDamz = useFlag('damz');
  const isDamzLoadTestRealtime = useFlag('damz_lt_rt');
  const isDamzLoadTestRealtimeCounts = useFlag('damz_lt_rt_ct');
  const isMounted = useIsMounted();

  const canDamz =
    isDamz || isDamzLoadTestRealtime || isDamzLoadTestRealtimeCounts;

  // Must have dep, feature, and not be SSR
  if (!GlobalComponent || !canDamz || !isMounted) {
    return null;
  }

  return <GlobalComponent />;
};
DamzInit.displayName = 'DamzInit';

export default DamzInit;
